import reducers from './reducers'

export { default as myCompanyTypes } from './types'
export { default as myCompanyActions } from './actions'
export { default as myCompanySelectors } from './selectors'
export { default as myCompanyEpics } from './epics'

export default reducers
